
function ClaimStatus() {
  return [
    { claimStatusID: 210, claimStatusName: "New" },
    { claimStatusID: 211, claimStatusName: "Open/Pending" },
    { claimStatusID: 212, claimStatusName: "Resolved" }
  ];
}
export default ClaimStatus;
